var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"bg-white focus:outline-none focus:border-primary border-2 border-info rounded-full py-3 px-4 block w-full appearance-none leading-normal",class:{
            'my-3': !_vm.noMargin
       },attrs:{"placeholder":_vm.innerLabel},domProps:{"value":_vm.innerValue},on:{"input":function($event){return _vm.validate($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }